import { Injectable, signal } from '@angular/core'
import { SmartQuoteFilter } from 'src/app/shared/interfaces/smartquote/smart-quote-filter.interface'
import { Utils } from 'src/app/shared/utilties'

@Injectable({
    providedIn: 'root',
})
export class SmartquoteHelperService {
    private filter$ = signal<SmartQuoteFilter>({
        pageNumber: 1,
        pageSize: 20,
        dateRangeFilter: {
            from: Utils.getDateMinusDays(365),
            to: Utils.getDatePlusDays(1),
        },
    })

    filter = this.filter$.asReadonly()

    updateFilter(filter: SmartQuoteFilter): void {
        this.filter$.set(filter)
    }
}
